<template>
  <div class="container">
    <a-textarea :rows="12" style="resize: none" v-model="codes"></a-textarea>
    <a-button type="primary" style="margin-top: 8px"  @click="searchGoods" block>查询</a-button>
  </div>
</template>

<script>
import {reqRecordList} from '@/api/index'


// 格式化运单
function formatCodes(codes = "") {
  let codes_arr = codes.split("\n");
  let delete_empty_codes = arrayDeleteEmpty(codes_arr)
  if(isRepeat(delete_empty_codes)) {
    return window.alert('有重复运单号请仔细进行检查')
  }else{
    return delete_empty_codes
  }
}

// 数组去空
function arrayDeleteEmpty(array){
  return array.filter(item => item && item.trim())
}

// 判断数组中是否存在重复的元素
function isRepeat(arr){
   var hash = {};
   for(var i in arr) {
      if(hash[arr[i]])
        return true;
      hash[arr[i]] = true;
  }
  return false;
}

export default {
  data() {
    return {
      codes: "",
    };
  },
  mounted(){
    // console.log(this.$route);
    // 判断有没有携带 params 参数过来,如果有进行一次搜索
    this.codesFormParams(this.$route.params.codes)
  },
  methods: {
    // 搜索运单
    async searchGoods() {
      let new_codes = formatCodes(this.codes);
      if(!Array.isArray(new_codes)) return
      if(new_codes.length === 0) return this.$message.warning('请输入要填写的单号')
      this.$store.commit('result/updateTrackNoList',new_codes)

      const res = await reqRecordList({ codes: new_codes });
      if (res.data.code === 1) {
        this.$message.success(res.data.msg);
        this.$store.commit("result/updateRecordList", res.data.data);
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 通过路由来的参数
    codesFormParams(codes){
      if(!codes) return
      this.codes = codes
      this.searchGoods()
    }
  },
};
</script>

<style lang="less" scoped>
</style>